module.exports = __webpack_public_path__ + "static/media/chocolate-chunk.2869cd52.png";